// tanstack
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/predictive-heat-control/',
)({
  component: () => {
    return <Navigate to="buildings" />;
  },
});
